<template>
  <Layout>
    <section>
      <header>
        <h2>{{ 'Payment Details' | t }}</h2>
      </header>
      <main>
        <router-view />
      </main>
    </section>
  </Layout>
</template>

<script>
import t from '../../main/i18n';
import Layout from '../components/Layout.vue';

export default {
  components: {
    Layout
  },
  filters: {
    t
  }
};
</script>

<style lang="scss">
@import '../../../scss/variables';
@import '../../../scss/system';

.personal-details {
  border: 1px solid $color-gray-400;
  border-radius: 1.2rem;

  &--footer {
    border-top: 1px solid $color-gray-400;
  }

  .slo-modal {
    &-footer > .slo-button {
      flex: 1;
    }
  }

  .fixed-button-width {
    flex-basis: 84px;
  }
}

.payment-details {
  &--saved-payment-methods {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1.6rem;
    list-style: none;
    margin-bottom: 3.2rem;
    padding: 0 1.6rem;

    @media (min-width: $screen-sm) {
      padding: 0 3.2rem;
    }

    @media (min-width: $screen-md) {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  &--saved-payment-method {
    position: relative;
    padding: 1.6rem;
    border: 1px solid $color-gray-400;
    border-radius: 0.8rem;
    transition: border-color 0.15s ease-in, box-shadow 0.15s ease-in;

    &:hover {
      border-color: $color-gray-600;
    }

    svg {
      filter: grayscale(1) opacity(0.6);
    }

    &.checked {
      border-color: $color-blue-400;
      box-shadow: inset 0 0 0 1px $color-blue-400;

      .slo-icon:not(.card-icon) {
        opacity: 1;
        scale: 1;
      }

      svg {
        filter: none;
      }

      .saved-payment-method--title {
        color: $color-blue-400;
      }
    }

    .saved-payment-method--details {
      display: flex;
      flex-direction: column;
      align-items: start;
      justify-content: start;
      gap: 0.4rem;
      color: $color-gray-700;
    }

    .slo-icon:not(.card-icon) {
      position: absolute;
      top: 1.6rem;
      right: 1.6rem;
      color: $color-blue-400;
      opacity: 0;
      scale: 0.6;
      transition: opacity 0.15s ease-in, scale 0.15s ease-in;
    }

    .slo-icon.card-icon {
      color: $color-gray-900;
      font-size: 36px;
      width: 36px !important;
      height: 36px !important;
    }

    .saved-payment-method--title {
      max-width: 22ch;
      color: $color-gray-900;
      font-weight: 500;
      transition: color 0.15s ease-in;

      @media (min-width: $screen-sm) {
        max-width: 100%;
      }
    }
  }
}

.update-payment-details-grid {
  display: grid;
  gap: 1.6rem;

  @media (min-width: $screen-sm) {
    grid-template-columns: 1fr 1fr;
    gap: 1.6rem 2.4rem;
  }
}

.fade-up-enter, .fade-up-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

.fade-up-enter-active, .fade-up-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}

.paymetric-container {
  min-height: 480px;
  max-height: 480px;
  overflow: hidden;

  @media (min-width: 480px) and (max-width: 504px) {
    min-height: 480px;
    max-height: 480px;
  }

  @media (min-width: 505px) and (max-width: 767px) {
    min-height: 265px;
    max-height: 265px;
  }

  @media (min-width: 768px) and (max-width: 818px) {
    min-height: 480px;
    max-height: 480px;
  }

  @media (min-width: 819px) {
    min-height: 265px;
    max-height: 265px;
  }

  #paymetric-iframe {
    height: 100vh;
  }
}
</style>
